// extracted by mini-css-extract-plugin
module.exports = {"heading":"heading-module--heading--2PQyT","show":"heading-module--show--3i51u"};